import { Grid } from "@material-ui/core";
import BPago from "./BPago";
import TPagos from "./TPagos";
export default function VPagoUnico() {
  return (
    <Grid container>
      <Grid item xs={3}>
        <BPago />
      </Grid>
      <Grid item xs={9}>
        <TPagos />
      </Grid>
    </Grid>
  );
}
